import API from './resources'

const actions = {
  async disableProduct(_, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.disableProductDelete(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async updateProduct(_, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.updateProduct(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async postProduct(_, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.postProduct(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async getProducts({ commit, state }, payload) {
    try {
      if (state.is_active === null)  {
        const response = await API.getAllProducts(
          state.page,
          state.size,
          payload.token
        )
        commit('SET_PRODUCTS_LIST', response)
        commit('SET_PRODUCTS_PAGINATION', response)
      } else {
        const response = await API.getFilteredProducts(
          state.is_active,
          state.page,
          state.size,
          payload.token
        )
        commit('SET_PRODUCTS_LIST', response)
        commit('SET_PRODUCTS_PAGINATION', response)
      }
    } catch (error) {
      return error
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/product/actions.js